import React from 'react';
import { Star, ShieldCheck, ArrowUpRight, Monitor, UserCheck, Building2, CheckCircle, User, Headset } from 'lucide-react';

const HeroBanner = () => {
  return (
    <div className="bg-[#f5f5f5] font-sans w-full">
      {/* Main Content Area */}
      <div className="min-h-[500px] px-6 py-12 lg:px-20 flex flex-col lg:flex-row items-center justify-between gap-12">

        {/* Left Content Section */}
        <div className="flex-1 space-y-8">
          <span className="bg-[#E4F2E7] text-[#2D6A4F] px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide">
            Income Tax e Filing
          </span>

          <h1 className="text-4xl lg:text-6xl font-extrabold text-[#1F2937] leading-tight">
            Easiest Way of <br />
            Income Tax efiling in <br />
            <span className="text-[#168039]">India</span>
          </h1>

          <div className="flex flex-wrap items-center gap-8 pt-4">
            <div className="flex items-center gap-2">
              <div className="flex items-center">
                <Star size={20} className="fill-yellow-400 text-yellow-400" />
              </div>
              <span className="font-bold text-[#1F2937]">4.8 Google Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <ShieldCheck size={24} className="text-[#168039]" />
              <span className="font-bold text-[#1F2937]">1+ Million Trusted Users</span>
            </div>
          </div>
        </div>

        {/* Right Cards Section */}
        <div className="flex flex-col md:flex-row gap-6 w-full lg:w-auto">

          {/* Self ITR Card */}
          <div className="relative overflow-hidden bg-[#5D89BA] text-white p-8 rounded-[32px] w-full md:w-[340px] h-[420px] flex flex-col justify-between shadow-xl">
            <div className="space-y-4">
              <Monitor size={48} strokeWidth={1.5} />
              <h3 className="text-3xl font-bold">Self ITR Filing</h3>
              <p className="text-blue-50 opacity-90 leading-relaxed">
                It's quick, easy, and takes only 4 minutes to file your income tax return.
              </p>
            </div>
            <button className="bg-white text-[#1F2937] px-6 py-4 rounded-full font-bold flex items-center justify-between group hover:bg-blue-50 transition-colors">
              File ITR Now
              <span className="bg-[#5D89BA] p-1 rounded-full text-white ml-2">
                <ArrowUpRight size={18} />
              </span>
            </button>
            {/* Subtle wave effect background - simulated with a div */}
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
          </div>

          {/* Tax Expert Card */}
          <div className="relative overflow-hidden bg-[#168039] text-white p-8 rounded-[32px] w-full md:w-[340px] h-[420px] flex flex-col justify-between shadow-xl">
            {/* Discount Badge */}
            <div className="absolute top-6 right-6 bg-[#E91E63] text-white px-3 py-4 rounded-b-lg text-center leading-none shadow-lg">
              <div className="text-xl font-black">50%</div>
              <div className="text-[10px] font-bold uppercase mt-1">OFF</div>
            </div>

            <div className="space-y-4">
              <UserCheck size={48} strokeWidth={1.5} />
              <h3 className="text-3xl font-bold">Hire a Tax Expert</h3>
              <p className="text-green-50 opacity-90 leading-relaxed">
                Let a personal eCA handle your Income Tax Filing — hassle-free, fast, and focused on maximizing your refund
              </p>
            </div>
            <button className="bg-white text-[#1F2937] px-6 py-4 rounded-full font-bold flex items-center justify-between group hover:bg-green-50 transition-colors">
              Book eCA Now
              <span className="bg-[#168039] p-1 rounded-full text-white ml-2">
                <ArrowUpRight size={18} />
              </span>
            </button>
            <div className="absolute -bottom-10 -right-10 w-40 h-40 bg-black/10 rounded-full blur-3xl"></div>
          </div>

        </div>
      </div>

      {/* Bottom Features Bar */}
      <div className="px-6 pb-12 lg:px-20 max-w-[1400px] mx-auto">
        <div className="bg-white rounded-xl p-4 md:p-6 flex flex-wrap lg:flex-nowrap justify-between items-center gap-y-4 shadow-sm">
          <div className="flex items-center gap-3 w-full sm:w-1/2 lg:w-auto justify-center lg:justify-start px-2 border-b sm:border-b-0 lg:border-r border-gray-100 pb-2 sm:pb-0">
            <Building2 className="text-orange-500 shrink-0" size={24} />
            <span className="font-semibold text-gray-700 whitespace-nowrap">Business Registration</span>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-1/2 lg:w-auto justify-center lg:justify-start px-2 border-b sm:border-b-0 lg:border-r border-gray-100 pb-2 sm:pb-0">
            <CheckCircle className="text-green-600 shrink-0" size={24} />
            <span className="font-semibold text-gray-700 whitespace-nowrap">GST Compliance</span>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-1/2 lg:w-auto justify-center lg:justify-start px-2 border-b sm:border-b-0 lg:border-r border-gray-100 pb-2 sm:pb-0">
            <User className="text-orange-500 shrink-0" size={24} />
            <span className="font-semibold text-gray-700 whitespace-nowrap">MCA Compliance</span>
          </div>
          <div className="flex items-center gap-3 w-full sm:w-1/2 lg:w-auto justify-center lg:justify-start px-2">
            <Headset className="text-green-600 shrink-0" size={24} />
            <span className="font-semibold text-gray-700 whitespace-nowrap">Income Tax Filing</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;